import React from 'react';
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core'; // PlanSection: Reusable for Plan A and Plan B
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';

// PlanSection: Reusable for Plan A and Plan B
const PlanSection = ({
  planType,
  form,
  setForm,
  disabled,
  classes,
  OPTIONS,
  getPlanMenuItems,
  createPrintedList,
  calculateCosts,
  dateUtcToS,
  saveMilitaryMEPSDateTask,
  saveMilitaryBasicTrainingDateTask,
  safePlanValue,
  ExpandingList,
  LuxonUtils,
}) => {
  // Map planType to field suffixes
  const suffix = planType === 'A' ? 'A' : 'B';
  // Helper to get field name for plan
  const field = (base) => `${base}${suffix}`;
  const myFuturePlan = form[field('myFuturePlan')];

  return (
    <Box sx={{ width: '95%' }} className={classes.box + ' ' + (planType === 'A' ? classes.boxA : classes.boxB)}>
      {/* Plan Select */}
      <Grid container direction="row" className={classes.unprintedContent}>
        <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer} style={{ marginTop: '15px' }}>
          <InputLabel id={`plan-for-fall-label${planType}`} htmlFor={`plan-for-fall${planType}`} className={classes.bold}>
            {`Plan ${planType}`}
          </InputLabel>
        </Grid>
        <Grid item xs={12} sm={8} md={8} lg={4} className={classes.textRowSpacer}>
          <FormControl fullWidth>
            <Select
              variant="outlined"
              labelId={`plan-for-fall-label${planType}`}
              id={`plan-for-fall${planType}`}
              value={safePlanValue}
              onChange={(event) =>
                setForm({
                  ...form,
                  [field('myFuturePlan')]: event.target.value,
                  status: form.status === '' ? 'created' : form.status,
                })
              }
              displayEmpty
              disabled={disabled}
              className={classes.textFieldBackground}
              renderValue={(selected) => (selected ? OPTIONS.find((o) => o.value === selected)?.label : `Select Option for Plan ${planType}`)}
            >
              <MenuItem value="" disabled>
                {`Select Option for Plan ${planType}`}
              </MenuItem>
              {getPlanMenuItems(form)}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <div className={classes.printedContent}>
        <Grid container direction="row" className={classes.printedContent}>
          <Grid item xs={4}>
            <label className={classes.alignPrintedContent}>{`Plan ${planType}`}</label>
          </Grid>
          <Grid item xs={8}>
            <summary className={classes.alignPrintedContent}>{OPTIONS.find((o) => o.value === form[field('myFuturePlan')])?.label || null}</summary>
          </Grid>
        </Grid>
      </div>

      {/* College Section */}
      {(myFuturePlan === 'college' || myFuturePlan === '2-year-college') && (
        <React.Fragment>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item lg={3} />
            <Grid item xs={12} lg={9} className={classes.textRowSpacer} style={{ marginTop: '10px', justifyContent: 'center' }}>
              <Typography variant="body1" className={classes.reminder}>
                REMINDER: Bring my acceptance letter with me to the 2nd meeting.
              </Typography>
            </Grid>
          </Grid>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}>
              <label htmlFor={`college-name-location-${planType}`}>College Name/Location</label>
            </Grid>
            <Grid item xs={12} sm={8} md={8} lg={9} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id={`college-name-location-${planType}`}
                  size="small"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('nameLocation')]}
                  onChange={(event) =>
                    setForm({
                      ...form,
                      [field('nameLocation')]: event.target.value,
                      status: form.status === '' ? 'created' : form.status,
                    })
                  }
                  inputProps={{ maxLength: 100, className: classes.textField }}
                  disabled={disabled}
                />
              </FormControl>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <div>
              <label className={classes.alignPrintedContent}>College Name/Location</label>
            </div>
            <div>
              <span className={classes.alignPrintedContent}>{form[field('nameLocation')] || null}</span>
            </div>
          </div>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}>
              <label htmlFor={`fall-4-year-major-${planType}`}>Major</label>
            </Grid>
            <Grid item xs={12} sm={5} md={4} lg={4} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id={`fall-4-year-major-${planType}`}
                  size="small"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('fall4YearMajor')]}
                  onChange={(event) =>
                    setForm({
                      ...form,
                      [field('fall4YearMajor')]: event.target.value,
                      status: form.status === '' ? 'created' : form.status,
                    })
                  }
                  inputProps={{ maxLength: 100, className: classes.textField }}
                  disabled={disabled}
                />
              </FormControl>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <Grid container direction="row" className={classes.printedContent}>
              <Grid item xs={4}>
                <label className={classes.alignPrintedContent}>Major</label>
              </Grid>
              <Grid item xs={8}>
                <span className={classes.alignPrintedContent}>{form[field('fall4YearMajor')] || null}</span>
              </Grid>
            </Grid>
          </div>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}>
              <label htmlFor={`fall-4-year-career-goal-${planType}`}>Career Goals</label>
            </Grid>
            <Grid item xs={12} sm={8} md={8} lg={9} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id={`fall-4-year-career-goal-${planType}`}
                  size="small"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('fall4YearCareerGoal')]}
                  onChange={(event) =>
                    setForm({
                      ...form,
                      [field('fall4YearCareerGoal')]: event.target.value,
                      status: form.status === '' ? 'created' : form.status,
                    })
                  }
                  inputProps={{ maxLength: 250, className: classes.textField }}
                  disabled={disabled}
                />
              </FormControl>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <div>
              <label className={classes.alignPrintedContent}>Career Goals</label>
            </div>
            <div>
              <span className={classes.alignPrintedContent}>{form[field('fall4YearCareerGoal')] || null}</span>
            </div>
          </div>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}>
              <label htmlFor={`fall-4-year-start-date-${planType}`}>Start Date</label>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={3} className={classes.datePickerRowSpacer}>
              {!disabled ? (
                <MuiPickersUtilsProvider utils={LuxonUtils}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    id={`fall-4-year-start-date-${planType}`}
                    hiddenLabel
                    value={form[field('fall4YearStartDate')] || null}
                    onChange={(date) => {
                      setForm({
                        ...form,
                        [field('fall4YearStartDate')]: date ? date : null,
                        status: form.status === '' ? 'created' : form.status,
                      });
                    }}
                    format="MM/dd/yyyy"
                    className={classes.datepicker}
                    disabled={disabled}
                  />
                </MuiPickersUtilsProvider>
              ) : (
                <span style={{ marginTop: 3 }} className={classes.subtleBold}>
                  {dateUtcToS(form[field('fall4YearStartDate')])}
                </span>
              )}
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <Grid container direction="row" className={classes.printedContent}>
              <Grid item xs={4}>
                <label className={classes.alignPrintedContent}>Start Date</label>
              </Grid>
              <Grid item xs={8}>
                <span className={classes.alignPrintedContent}>{dateUtcToS(form[field('fall4YearStartDate')])}</span>
              </Grid>
            </Grid>
          </div>
          {/* Costs Section */}
          <Grid container direction="row" className={classes.sectionSpacer + ' ' + classes.unprintedContent}>
            <Grid item xs={12} align="left">
              <section align="left" className={classes.textRowLabelSpacer}>
                Costs
              </section>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <div>
              <label className={classes.textRowLabelSpacer}>Costs</label>
            </div>
          </div>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={false} sm={1} md={1} lg={1} />
            <Grid item xs={12} sm={12} md={6} lg={2} className={classes.textRowLabelSpacer}>
              <label htmlFor={`fall-4-year-cost-tuition-${planType}`}>Tuition</label>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={2} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id={`fall-4-year-cost-tuition-${planType}`}
                  size="small"
                  type="text"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('fall4YearCostTuition')] || ''}
                  onChange={(event) => {
                    const value = event.target.value.replace(/\D/g, '').slice(0, 5);
                    setForm({
                      ...form,
                      [field('fall4YearCostTuition')]: value,
                      status: form.status === '' ? 'created' : form.status,
                    });
                  }}
                  disabled={disabled}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    classes: { input: classes.textField },
                  }}
                  inputProps={{ maxLength: 5 }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={false} sm={1} md={1} lg={2} />
            <Grid item xs={12} sm={12} md={6} lg={2} className={classes.textRowLabelSpacer}>
              <label htmlFor={`fall-4-year-cost-books-${planType}`}>Books</label>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={2} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id={`fall-4-year-cost-books-${planType}`}
                  size="small"
                  type="text"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('fall4YearCostBooks')] || ''}
                  onChange={(event) => {
                    const value = event.target.value.replace(/\D/g, '').slice(0, 5);
                    setForm({
                      ...form,
                      [field('fall4YearCostBooks')]: value,
                      status: form.status === '' ? 'created' : form.status,
                    });
                  }}
                  disabled={disabled}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    classes: { input: classes.textField },
                  }}
                  inputProps={{ maxLength: 5 }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <Grid container direction="row">
              <Grid item xs={4}>
                <label className={classes.alignPrintedContent}>Tuition</label>
              </Grid>
              <Grid item xs={2}>
                <summary className={classes.alignPrintedContent}>$ {form[field('fall4YearCostTuition')] || 0}</summary>
              </Grid>
              <Grid item xs={4}>
                <label className={classes.alignPrintedContent}>Books</label>
              </Grid>
              <Grid item xs={2}>
                <summary className={classes.alignPrintedContent}>$ {form[field('fall4YearCostBooks')] || 0}</summary>
              </Grid>
              <Grid item xs={4}>
                <label className={classes.alignPrintedContent}>Housing</label>
              </Grid>
              <Grid item xs={2}>
                <summary className={classes.alignPrintedContent}>$ {form[field('fall4YearCostHousing')] || 0}</summary>
              </Grid>
              <Grid item xs={4}>
                <label className={classes.alignPrintedContent}>Other Fees</label>
              </Grid>
              <Grid item xs={2}>
                <summary className={classes.alignPrintedContent}>$ {form[field('fall4YearCostOther')] || 0}</summary>
              </Grid>
              <Grid item xs={4}>
                <label className={classes.alignPrintedContent}>Meal Plan</label>
              </Grid>
              <Grid item xs={2}>
                <summary className={classes.alignPrintedContent}>$ {form[field('fall4YearCostMealPlan')] || 0}</summary>
              </Grid>
              <Grid item xs={4}>
                <label className={classes.alignPrintedContent}>Total</label>
              </Grid>
              <Grid item xs={2}>
                <summary className={classes.alignPrintedContent}>
                  ${' '}
                  {[
                    form[field('fall4YearCostTuition')],
                    form[field('fall4YearCostBooks')],
                    form[field('fall4YearCostHousing')],
                    form[field('fall4YearCostOther')],
                    form[field('fall4YearCostMealPlan')],
                  ]
                    .map((x) => parseInt(x, 10) || 0)
                    .reduce((a, b) => a + b, 0)}
                </summary>
              </Grid>
            </Grid>
          </div>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={false} sm={1} md={1} lg={1} />
            <Grid item xs={12} sm={12} md={6} lg={2} className={classes.textRowLabelSpacer}>
              <label htmlFor={`fall-4-year-cost-housing-${planType}`}>Housing</label>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={2} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id={`fall-4-year-cost-housing-${planType}`}
                  size="small"
                  type="text"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('fall4YearCostHousing')] || ''}
                  onChange={(event) => {
                    const value = event.target.value.replace(/\D/g, '').slice(0, 5);
                    setForm({
                      ...form,
                      [field('fall4YearCostHousing')]: value,
                      status: form.status === '' ? 'created' : form.status,
                    });
                  }}
                  disabled={disabled}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    classes: { input: classes.textField },
                  }}
                  inputProps={{ maxLength: 5 }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={false} sm={1} md={1} lg={2} />
            <Grid item xs={6} sm={3} md={3} lg={2} className={classes.textRowLabelSpacer}>
              <label htmlFor={`fall-4-year-cost-other-${planType}`}>Other Fees</label>
            </Grid>
            <Grid item xs={4} sm={2} md={2} lg={2} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id={`fall-4-year-cost-other-${planType}`}
                  size="small"
                  type="text"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('fall4YearCostOther')] || ''}
                  onChange={(event) => {
                    const value = event.target.value.replace(/\D/g, '').slice(0, 5);
                    setForm({
                      ...form,
                      [field('fall4YearCostOther')]: value,
                      status: form.status === '' ? 'created' : form.status,
                    });
                  }}
                  disabled={disabled}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    classes: { input: classes.textField },
                  }}
                  inputProps={{ maxLength: 5 }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={false} sm={1} md={1} lg={1} />
            <Grid item xs={6} sm={3} md={3} lg={2} className={classes.textRowLabelSpacer}>
              <label htmlFor={`fall-4-year-cost-mealplan-${planType}`}>Meal Plan</label>
            </Grid>
            <Grid item xs={4} sm={2} md={2} lg={2} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id={`fall-4-year-cost-mealplan-${planType}`}
                  size="small"
                  type="text"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('fall4YearCostMealPlan')] || ''}
                  onChange={(event) => {
                    const value = event.target.value.replace(/\D/g, '').slice(0, 5);
                    setForm({
                      ...form,
                      [field('fall4YearCostMealPlan')]: value,
                      status: form.status === '' ? 'created' : form.status,
                    });
                  }}
                  disabled={disabled}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    classes: { input: classes.textField },
                  }}
                  inputProps={{ maxLength: 5 }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={false} sm={1} md={1} lg={2} />
            <Grid item xs={6} sm={3} md={3} lg={2} className={classes.textRowLabelSpacer}>
              <summary className={classes.subtleBoldLabel}>Total</summary>
            </Grid>
            <Grid item xs={4} sm={2} md={2} lg={2} className={classes.paddingDataDisplay + ' ' + classes.subtleBold}>
              $ {calculateCosts(form, planType)}
            </Grid>
          </Grid>
          {/* Payment Plan Section */}
          <Grid container direction="row" className={classes.sectionSpacer + ' ' + classes.unprintedContent}>
            <Grid item xs={12} align="left">
              <section align="left" className={classes.textRowLabelSpacer}>
                Payment Plan
              </section>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <div>
              <label className={classes.textRowLabelSpacer}>Payment Plan</label>
            </div>
          </div>
          <Grid container direction="row" style={{ height: '185px', overflow: 'auto' }} className={classes.unprintedContent}>
            <Grid item xs={false} sm={1} md={1} lg={1} />
            <Grid item xs={12} sm={3} md={3} lg={2} className={classes.textRowLabelSpacer}>
              <label>Scholarships Granted</label>
            </Grid>
            <Grid item xs={12} sm={8} md={8} lg={8} className={classes.textRowSpacer}>
              <ExpandingList
                form={form}
                setForm={setForm}
                listname={field('scholarships')}
                field1="name"
                field1Cols={11}
                field1MaxLength={100}
                rowsRequired={3}
                disabled={disabled}
                maxFields={5}
              />
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <div>
              <label className={classes.alignPrintedContent}>Scholarships Granted</label>
            </div>
            <div>
              <summary className={classes.alignPrintedContent}>{createPrintedList(form[field('scholarships')])}</summary>
            </div>
          </div>
          <Grid container direction="row" style={{ height: '185px', overflow: 'auto' }} className={classes.unprintedContent}>
            <Grid item xs={false} sm={1} md={1} lg={1} />
            <Grid item xs={12} sm={3} md={3} lg={2} className={classes.textRowLabelSpacer}>
              <label>Loans</label>
            </Grid>
            <Grid item xs={12} sm={8} md={8} lg={8} className={classes.textRowSpacer}>
              <ExpandingList
                form={form}
                setForm={setForm}
                listname={field('loans')}
                field1="name"
                field1Cols={11}
                field1MaxLength={100}
                rowsRequired={3}
                disabled={disabled}
                maxFields={5}
              />
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <div>
              <label className={classes.alignPrintedContent}>Loans</label>
            </div>
            <div>
              <summary className={classes.alignPrintedContent}>{createPrintedList(form[field('loans')])}</summary>
            </div>
          </div>
        </React.Fragment>
      )}

      {/* Career Training Section */}
      {myFuturePlan === 'career_training' && (
        <React.Fragment>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item lg={3} />
            <Grid item xs={12} lg={9} className={classes.textRowSpacer} style={{ marginTop: '20px', justifyContent: 'center' }}>
              <Typography variant="body1" className={classes.reminder}>
                REMINDER: Bring my acceptance letter with me to the 2nd meeting.
              </Typography>
            </Grid>
          </Grid>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowSpacer}>
              <label>College/School Name/Location</label>
            </Grid>
            <Grid item xs={12} sm={7} md={7} lg={6} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id={`fall-cc-trade-name-location-${planType}`}
                  size="small"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('fallCCTradeNameLocation')]}
                  onChange={(event) =>
                    setForm({
                      ...form,
                      [field('fallCCTradeNameLocation')]: event.target.value,
                      status: form.status === '' ? 'created' : form.status,
                    })
                  }
                  InputProps={{ classes: { input: classes.textField } }}
                  inputProps={{ maxLength: 100 }}
                  disabled={disabled}
                />
              </FormControl>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <Grid container direction="row" className={classes.printedContent}>
              <Grid item xs={12}>
                <label className={classes.alignPrintedContent}>College/School Name/Location</label>
              </Grid>
              <Grid item xs={12}>
                <summary className={classes.alignPrintedContent}>{form[field('fallCCTradeNameLocation')] || null}</summary>
              </Grid>
            </Grid>
          </div>
          <div className={classes.printedContent}>
            <div>
              <label className={classes.reminder}>REMINDER: Bring my acceptance letter with me to the 2nd meeting.</label>
            </div>
          </div>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}>
              <label htmlFor={`fall-trade-or-major-${planType}`}>Trade or Major</label>
            </Grid>
            <Grid item xs={12} sm={7} md={7} lg={6} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id={`fall-trade-or-major-${planType}`}
                  size="small"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('fallTradeOrMajor')]}
                  onChange={(event) =>
                    setForm({
                      ...form,
                      [field('fallTradeOrMajor')]: event.target.value,
                      status: form.status === '' ? 'created' : form.status,
                    })
                  }
                  InputProps={{ classes: { input: classes.textField } }}
                  inputProps={{ maxLength: 100 }}
                  disabled={disabled}
                />
              </FormControl>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <div>
              <label className={classes.alignPrintedContent}>Trade or Major</label>
            </div>
            <div>
              <summary className={classes.alignPrintedContent}>{form[field('fallTradeOrMajor')] || null}</summary>
            </div>
          </div>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}>
              <label>Start Date</label>
            </Grid>
            <Grid item xs={12} sm={4} md={3} lg={3} className={classes.datePickerRowSpacer}>
              {!disabled ? (
                <MuiPickersUtilsProvider utils={LuxonUtils}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    id={`fall-trade-start-date-${planType}`}
                    hiddenLabel
                    value={form[field('fallCCTradeStartDate')] || null}
                    onChange={(date) => {
                      setForm({
                        ...form,
                        [field('fallCCTradeStartDate')]: date ? date : null,
                        status: form.status === '' ? 'created' : form.status,
                      });
                    }}
                    format="MM/dd/yyyy"
                    className={classes.datepicker}
                    disabled={disabled}
                  />
                </MuiPickersUtilsProvider>
              ) : (
                <summary style={{ marginTop: 3 }} className={classes.subtleBold}>
                  {dateUtcToS(form[field('fallCCTradeStartDate')] || null)}
                </summary>
              )}
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <Grid container direction="row" className={classes.printedContent}>
              <Grid item xs={4}>
                <label className={classes.alignPrintedContent}>Start Date</label>
              </Grid>
              <Grid item xs={8}>
                <summary className={classes.alignPrintedContent}>{dateUtcToS(form[field('fallCCTradeStartDate')] || null)}</summary>
              </Grid>
            </Grid>
          </div>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}>
              <label htmlFor={`fall-cc-trade-career-goal-${planType}`}>Career Goals</label>
            </Grid>
            <Grid item xs={12} sm={7} md={7} lg={6} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id={`fall-cc-trade-career-goal-${planType}`}
                  size="small"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('fallCCTradeCareerGoal')]}
                  onChange={(event) =>
                    setForm({
                      ...form,
                      [field('fallCCTradeCareerGoal')]: event.target.value,
                      status: form.status === '' ? 'created' : form.status,
                    })
                  }
                  InputProps={{ classes: { input: classes.textField } }}
                  inputProps={{ maxLength: 250 }}
                  disabled={disabled}
                />
              </FormControl>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <div>
              <label className={classes.alignPrintedContent}>Career Goals</label>
            </div>
            <div>
              <summary className={classes.alignPrintedContent}>{form[field('fallCCTradeCareerGoal')] || null}</summary>
            </div>
          </div>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}>
              <label htmlFor={`myFuturePlan${planType}Cost`}>Cost</label>
            </Grid>
            <Grid item xs={12} sm={7} md={7} lg={6} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id={`myFuturePlan${planType}Cost`}
                  size="small"
                  type="text"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('myFuturePlanCost')] || ''}
                  onChange={(event) => {
                    const value = event.target.value.replace(/\D/g, '').slice(0, 5);
                    setForm({
                      ...form,
                      [field('myFuturePlanCost')]: value,
                      status: form.status === '' ? 'created' : form.status,
                    });
                  }}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    classes: { input: classes.textField },
                  }}
                  inputProps={{ maxLength: 5 }}
                  disabled={disabled}
                />
              </FormControl>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <div>
              <label className={classes.alignPrintedContent}>Cost</label>
            </div>
            <div>
              <summary className={classes.alignPrintedContent}>$ {form[field('myFuturePlanCost')] || 0}</summary>
            </div>
          </div>
          {/* Payment Plan Section */}
          <Grid container direction="row" className={classes.sectionSpacer + ' ' + classes.unprintedContent}>
            <Grid item xs={12} align="left">
              <section align="left" className={classes.textRowLabelSpacer}>
                Payment Plan
              </section>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <div>
              <label className={classes.textRowLabelSpacer}>Payment Plan</label>
            </div>
          </div>
          <Grid container direction="row" style={{ height: '185px', overflow: 'auto' }} className={classes.unprintedContent}>
            <Grid item xs={false} sm={1} md={1} lg={1} />
            <Grid item xs={12} sm={3} md={3} lg={2} className={classes.textRowLabelSpacer}>
              <label>Scholarships Granted</label>
            </Grid>
            <Grid item xs={12} sm={8} md={8} lg={8} className={classes.textRowSpacer}>
              <ExpandingList
                form={form}
                setForm={setForm}
                listname={field('scholarships')}
                field1="name"
                field1Cols={11}
                field1MaxLength={100}
                rowsRequired={3}
                disabled={disabled}
                maxFields={5}
              />
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <div>
              <label className={classes.alignPrintedContent}>Scholarships Granted</label>
            </div>
            <div>
              <summary className={classes.alignPrintedContent}>{createPrintedList(form[field('scholarships')])}</summary>
            </div>
          </div>
          <Grid container direction="row" style={{ height: '185px', overflow: 'auto' }} className={classes.unprintedContent}>
            <Grid item xs={false} sm={1} md={1} lg={1} />
            <Grid item xs={12} sm={3} md={3} lg={2} className={classes.textRowLabelSpacer}>
              <label>Loans</label>
            </Grid>
            <Grid item xs={12} sm={8} md={8} lg={8} className={classes.textRowSpacer}>
              <ExpandingList
                form={form}
                setForm={setForm}
                listname={field('loans')}
                field1="name"
                field1Cols={11}
                field1MaxLength={100}
                rowsRequired={3}
                disabled={disabled}
                maxFields={5}
              />
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <div>
              <label className={classes.alignPrintedContent}>Loans</label>
            </div>
            <div>
              <summary className={classes.alignPrintedContent}>{createPrintedList(form[field('loans')])}</summary>
            </div>
          </div>
        </React.Fragment>
      )}
      {myFuturePlan === 'military' && (
        <React.Fragment>
          <Grid container direction="row" className={classes.unprintedContent} style={{ marginTop: '20px' }}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}>
              <label>Branch of Military</label>
            </Grid>
            <Grid item xs={12} sm={5} md={4} lg={6} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id="fall-military-branch"
                  size="small"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('fallMilitaryBranch')]}
                  onChange={(event) =>
                    setForm({
                      ...form,
                      [field('fallMilitaryBranch')]: event.target.value,
                      status: form.status === '' ? 'created' : form.status,
                    })
                  }
                  disabled={disabled}
                  InputProps={{ classes: { input: classes.textField } }}
                  inputProps={{ maxLength: 50 }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <Grid container direction="row" className={classes.printedContent}>
              <Grid item xs={4}>
                <label className={classes.alignPrintedContent}>Branch of Military</label>
              </Grid>
              <Grid item xs={8}>
                <summary className={classes.alignPrintedContent}>{form[field('fallMilitaryBranch')] || null}</summary>
              </Grid>
            </Grid>
          </div>

          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={12} sm={6} md={4} lg={3} className={classes.textRowLabelSpacer}>
              <label>MEPS Date</label>
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={3} className={classes.datePickerRowSpacer}>
              {!disabled ? (
                <MuiPickersUtilsProvider utils={LuxonUtils}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    id="fall-military-meps-date"
                    hiddenLabel
                    value={form[field('fallMilitaryMepsDateDoNotKnow')] ? null : form[field('fallMilitaryMepsDate')] || null}
                    onChange={(date) => {
                      setForm({
                        ...form,
                        [field('fallMilitaryMepsDate')]: date ? date : null,
                        status: form.status === '' ? 'created' : form.status,
                      });
                    }}
                    format="MM/dd/yyyy"
                    className={classes.datepicker}
                    disabled={disabled}
                  />
                </MuiPickersUtilsProvider>
              ) : (
                <summary style={{ marginTop: 3 }} className={classes.subtleBold}>
                  {form[field('fallMilitaryMepsDateDoNotKnow')] ? 'Unknown' : dateUtcToS(form[field('fallMilitaryMepsDate')] || null)}
                </summary>
              )}
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={3} className={classes.datePickerRowSpacer}>
              <FormControlLabel
                control={
                  <Tooltip title="Student does not yet know their MEPS date." placement="top">
                    <Checkbox
                      color="default"
                      disabled={disabled}
                      checked={form[field('fallMilitaryMepsDateDoNotKnow')] ? form[field('fallMilitaryMepsDateDoNotKnow')] : false}
                      onChange={() => saveMilitaryMEPSDateTask(!form[field('fallMilitaryMepsDateDoNotKnow')], planType)}
                    />
                  </Tooltip>
                }
                label="Do Not Know"
              />
            </Grid>
          </Grid>
          {form[field('fallMilitaryMepsDateDoNotKnow')] && (
            <Grid container direction="row" className={classes.unprintedContent}>
              <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}></Grid>
              <Grid item xs={12} sm={8} md={8} lg={9} className={classes.textRowSpacer}>
                <FormControl fullWidth>
                  <TextField
                    id="fall-military-MEPS-do-not-know-reason"
                    size="small"
                    label="Explain why you do not know your MEPS date"
                    variant="outlined"
                    value={form[field('fallMilitaryMepsDateDoNotKnowReason')]}
                    onChange={(event) => {
                      setForm({ ...form, [field('fallMilitaryMepsDateDoNotKnowReason')]: event.target.value });
                    }}
                    disabled={disabled}
                    InputProps={{ classes: { input: classes.textField } }}
                    inputProps={{ maxLength: 100 }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          )}
          <div className={classes.printedContent}>
            <Grid container direction="row" className={classes.printedContent}>
              <Grid item xs={4}>
                <label className={classes.alignPrintedContent}>MEPS Date</label>
              </Grid>
              <Grid item xs={8}>
                <summary className={classes.alignPrintedContent}>
                  {form[field('fallMilitaryMepsDateDoNotKnow')] ? 'Unknown' : dateUtcToS(form[field('fallMilitaryMepsDate')] || null)}
                </summary>
              </Grid>
            </Grid>
          </div>
          {form[field('fallMilitaryMepsDateDoNotKnow')] && (
            <div className={classes.printedContent}>
              <Grid container direction="row" className={classes.printedContent}>
                <Grid item xs={4}>
                  <label className={classes.alignPrintedContent}>Reason</label>
                </Grid>
                <Grid item xs={8}>
                  <summary className={classes.alignPrintedContent}>{form[field('fallMilitaryMepsDateDoNotKnowReason')]}</summary>
                </Grid>
              </Grid>
            </div>
          )}

          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}>
              <label>Basic Training Date</label>
            </Grid>
            <Grid item xs={6} sm={5} md={4} lg={3} className={classes.datePickerRowSpacer}>
              {!disabled ? (
                <MuiPickersUtilsProvider utils={LuxonUtils}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    id="fall-military-basic-training-date"
                    hiddenLabel
                    disabled={disabled}
                    value={form[field('fallMilitaryBasicTrainingDateDoNotKnow')] ? null : form[field('fallMilitaryBasicTrainingDate')] || null}
                    onChange={(date) => {
                      setForm({
                        ...form,
                        [field('fallMilitaryBasicTrainingDate')]: date ? date : null,
                        status: form.status === '' ? 'created' : form.status,
                      });
                    }}
                    format="MM/dd/yyyy"
                    className={classes.datepicker}
                  />
                </MuiPickersUtilsProvider>
              ) : (
                <summary style={{ marginTop: 3 }} className={classes.subtleBold}>
                  {form[field('fallMilitaryBasicTrainingDateDoNotKnow')]
                    ? 'Unknown'
                    : dateUtcToS(form[field('fallMilitaryBasicTrainingDate')] || null)}
                </summary>
              )}
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={3} className={classes.datePickerRowSpacer}>
              <FormControlLabel
                control={
                  <Tooltip title="Student does not yet know their basic training date." placement="top">
                    <Checkbox
                      color="default"
                      disabled={disabled}
                      checked={form[field('fallMilitaryBasicTrainingDateDoNotKnow')] ? form[field('fallMilitaryBasicTrainingDateDoNotKnow')] : false}
                      onChange={() => saveMilitaryBasicTrainingDateTask(!form[field('fallMilitaryBasicTrainingDateDoNotKnow')], planType)}
                    />
                  </Tooltip>
                }
                label="Do Not Know"
              />
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <Grid container direction="row" className={classes.printedContent}>
              <Grid item xs={4}>
                <label className={classes.alignPrintedContent}>Basic Training Date</label>
              </Grid>
              <Grid item xs={8}>
                <summary className={classes.alignPrintedContent}>
                  {form[field('fallMilitaryBasicTrainingDateDoNotKnow')]
                    ? 'Unknown'
                    : dateUtcToS(form[field('fallMilitaryBasicTrainingDate')] || null)}
                </summary>
              </Grid>
            </Grid>
          </div>
          {form[field('fallMilitaryBasicTrainingDateDoNotKnow')] && (
            <div className={classes.printedContent}>
              <Grid container direction="row" className={classes.printedContent}>
                <Grid item xs={4}>
                  <label className={classes.alignPrintedContent}>Reason</label>
                </Grid>
                <Grid item xs={8}>
                  <summary className={classes.alignPrintedContent}>{form[field('fallMilitaryBasicTrainingDateDoNotKnowReason')]}</summary>
                </Grid>
              </Grid>
            </div>
          )}
          {form[field('fallMilitaryBasicTrainingDateDoNotKnow')] && (
            <Grid container direction="row" className={classes.unprintedContent}>
              <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}></Grid>
              <Grid item xs={12} sm={8} md={8} lg={9} className={classes.textRowSpacer}>
                <FormControl fullWidth>
                  <TextField
                    id="fall-military-basic-training-date-do-not-know-reason"
                    size="small"
                    label="Explain why you do not know your basic training date"
                    variant="outlined"
                    value={form[field('fallMilitaryBasicTrainingDateDoNotKnowReason')]}
                    onChange={(event) => setForm({ ...form, [field('fallMilitaryBasicTrainingDateDoNotKnowReason')]: event.target.value })}
                    disabled={disabled}
                    InputProps={{ classes: { input: classes.textField } }}
                    inputProps={{ maxLength: 100 }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          )}
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}>
              <label>Name of Recruiter</label>
            </Grid>
            <Grid item xs={12} sm={5} md={4} lg={6} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id="fall-military-recruiter"
                  size="small"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('fallMilitaryRecruiter')]}
                  onChange={(event) =>
                    setForm({
                      ...form,
                      [field('fallMilitaryRecruiter')]: event.target.value,
                      status: form.status === '' ? 'created' : form.status,
                    })
                  }
                  disabled={disabled}
                  InputProps={{ classes: { input: classes.textField } }}
                  inputProps={{ maxLength: 50 }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <Grid container direction="row" className={classes.printedContent}>
              <Grid item xs={4}>
                <label className={classes.alignPrintedContent}>Name of Recruiter</label>
              </Grid>
              <Grid item xs={8}>
                <summary className={classes.alignPrintedContent}>{form.fallMilitaryRecruiter || null}</summary>
              </Grid>
            </Grid>
          </div>
        </React.Fragment>
      )}

      {myFuturePlan === 'workforce' && (
        <React.Fragment>
          <Grid container direction="row" className={classes.unprintedContent} style={{ marginTop: '20px' }}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}>
              <label>Place of Employment</label>
            </Grid>
            <Grid item xs={12} sm={6} md={5} lg={4} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id="fall-employment-place"
                  size="small"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('fallEmploymentPlace')]}
                  onChange={(event) =>
                    setForm({
                      ...form,
                      [field('fallEmploymentPlace')]: event.target.value,
                      status: form.status === '' ? 'created' : form.status,
                    })
                  }
                  disabled={disabled}
                  InputProps={{ classes: { input: classes.textField } }}
                  inputProps={{ maxLength: 100 }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <div>
              <label className={classes.alignPrintedContent}>Place of Employment</label>
            </div>
            <div>
              <summary className={classes.alignPrintedContent}>{form.fallEmploymentPlace || null}</summary>
            </div>
          </div>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}>
              <label htmlFor={`work-force-start-date-${planType}`}>Start Date</label>
            </Grid>
            <Grid item xs={6} sm={4} md={4} lg={3} className={classes.datePickerRowSpacer}>
              {!disabled ? (
                <MuiPickersUtilsProvider utils={LuxonUtils}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    id={`work-force-start-date-${planType}`}
                    hiddenLabel
                    value={form[field('workForceStartDate')] || null}
                    onChange={(date) => {
                      setForm({
                        ...form,
                        [field('workForceStartDate')]: date ? date : null,
                        status: form.status === '' ? 'created' : form.status,
                      });
                    }}
                    format="MM/dd/yyyy"
                    className={classes.datepicker}
                    disabled={disabled}
                  />
                </MuiPickersUtilsProvider>
              ) : (
                <span style={{ marginTop: 3 }} className={classes.subtleBold}>
                  {dateUtcToS(form[field('workForceStartDate')])}
                </span>
              )}
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <Grid container direction="row" className={classes.printedContent}>
              <Grid item xs={4}>
                <label className={classes.alignPrintedContent}>Start Date</label>
              </Grid>
              <Grid item xs={8}>
                <span className={classes.alignPrintedContent}>{dateUtcToS(form[field('workForceStartDate')])}</span>
              </Grid>
            </Grid>
          </div>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}>
              <label>Type of Employment</label>
            </Grid>
            <Grid item xs={12} sm={8} md={7} lg={6} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <RadioGroup
                  row
                  aria-label="fall employment type"
                  Ï
                  name="fall-employment-type"
                  value={form[field('fallEmploymentFullPartTime')]}
                  onChange={(event) =>
                    setForm({
                      ...form,
                      [field('fallEmploymentFullPartTime')]: event.target.value,
                      status: form.status === '' ? 'created' : form.status,
                    })
                  }
                  disabled={disabled}
                >
                  <FormControlLabel
                    value="full-time"
                    control={<Radio color="default" disabled={disabled} />}
                    label={<span className={classes.radioLabel}>Full Time (34+ hrs/wk)</span>}
                  />
                  <FormControlLabel
                    value="part-time"
                    control={<Radio color="default" disabled={disabled} />}
                    label={<span className={classes.radioLabel}>Part Time</span>}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <Grid container direction="row" className={classes.printedContent}>
              <Grid item xs={4}>
                <label className={classes.alignPrintedContent}>Type of Employment</label>
              </Grid>
              <Grid item xs={8}>
                <summary className={classes.alignPrintedContent}>{form[field('fallEmploymentFullPartTime')] || null}</summary>
              </Grid>
            </Grid>
          </div>
        </React.Fragment>
      )}
      {['college', '2-year-college', 'career_training'].includes(myFuturePlan) && (
        <React.Fragment>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={false} sm={1} md={1} lg={1} />
            <Grid item xs={12} sm={3} md={2} lg={2} className={classes.textRowLabelSpacer}>
              <label>Family Assistance</label>
            </Grid>
            <Grid item xs={12} sm={8} md={8} lg={7} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id={`fall-4-year-family-assistance-${planType}`}
                  size="small"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('fall4YearFamilyAssistance')]}
                  onChange={(event) =>
                    setForm({
                      ...form,
                      [field('fall4YearFamilyAssistance')]: event.target.value,
                      status: form.status === '' ? 'created' : form.status,
                    })
                  }
                  disabled={disabled}
                  inputProps={{ maxLength: 250, className: classes.textField }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <div>
              <label className={classes.alignPrintedContent}>Family Assistance</label>
            </div>
            <div>
              <summary className={classes.alignPrintedContent}>{form[field('fall4YearFamilyAssistance')] || null}</summary>
            </div>
          </div>
        </React.Fragment>
      )}
      {['college', '2-year-college', 'career_training', 'workforce'].includes(myFuturePlan) && (
        <React.Fragment>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}>
              <label>Living Arrangements</label>
            </Grid>
            <Grid item xs={12} sm={8} md={8} lg={9} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id={`fall-4-year-living-arrangements-${planType}`}
                  size="small"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('fall4YearLivingArrangements')]}
                  onChange={(event) =>
                    setForm({
                      ...form,
                      [field('fall4YearLivingArrangements')]: event.target.value,
                      status: form.status === '' ? 'created' : form.status,
                    })
                  }
                  disabled={disabled}
                  inputProps={{ maxLength: 250, className: classes.textField }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <div>
              <label className={classes.alignPrintedContent}>Living Arrangements</label>
            </div>
            <div>
              <summary className={classes.alignPrintedContent}>{form[field('fall4YearLivingArrangements')] || null}</summary>
            </div>
          </div>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowLabelSpacer}>
              <label>Transportation Requirements</label>
            </Grid>
            <Grid item xs={12} sm={8} md={8} lg={9} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id={`fall-4-year-transportation-requirements-${planType}`}
                  size="small"
                  hiddenLabel
                  variant="outlined"
                  value={form[field('fall4YearTransportationRequirements')]}
                  onChange={(event) =>
                    setForm({
                      ...form,
                      [field('fall4YearTransportationRequirements')]: event.target.value,
                      status: form.status === '' ? 'created' : form.status,
                    })
                  }
                  disabled={disabled}
                  inputProps={{ maxLength: 250, className: classes.textField }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <div>
              <label className={classes.alignPrintedContent}>Transportation Requirements</label>
            </div>
            <div>
              <summary className={classes.alignPrintedContent}>{form[field('fall4YearTransportationRequirements')] || null}</summary>
            </div>
          </div>
        </React.Fragment>
      )}

      {/* Barriers, Supports, Tasks */}
      <Grid container direction="row" className={classes.textSpacer} />
      <Grid container direction="row">
        <Grid item xs={12}>
          <label>{`What are the general barriers you have at this point to continue with Plan ${planType}.`}</label>
        </Grid>
      </Grid>
      <Grid container direction="row">
        <Grid item xs={12} className={classes.textArea5RowSpacer + ' ' + classes.unprintedContent}>
          <FormControl fullWidth>
            <textarea
              aria-label={`my-future-plan-${planType}-barriers`}
              rows={2}
              maxLength={250}
              value={form[field('myFutureBarriers')]}
              onChange={(event) => setForm({ ...form, [field('myFutureBarriers')]: event.target.value })}
              disabled={disabled}
              className={`${classes.textAreaFont} ${classes.textAreaFixed}`}
              style={{ color: disabled && 'rgba(0, 0, 0, 0.2)' }}
            />
          </FormControl>
        </Grid>
      </Grid>
      <p className={classes.printedContent} style={{ whiteSpace: 'pre-wrap' }}>
        {form[field('myFutureBarriers')] || null}
      </p>
      <Grid container direction="row" className={classes.textSpacer} />
      <Grid container direction="row">
        <Grid item xs={12}>
          <label>{`What supports do you need to continue with Plan ${planType}?`}</label>
        </Grid>
      </Grid>
      <Grid container direction="row">
        <Grid item xs={12} className={classes.textArea5RowSpacer + ' ' + classes.unprintedContent}>
          <FormControl fullWidth>
            <textarea
              aria-label={`my-future-plan-${planType}-supports`}
              rows={2}
              maxLength={250}
              value={form[field('myFutureSupports')]}
              onChange={(event) => setForm({ ...form, [field('myFutureSupports')]: event.target.value })}
              disabled={disabled}
              className={`${classes.textAreaFont} ${classes.textAreaFixed}`}
              style={{ color: disabled && 'rgba(0, 0, 0, 0.2)' }}
            />
          </FormControl>
        </Grid>
      </Grid>
      <p className={classes.printedContent} style={{ whiteSpace: 'pre-wrap' }}>
        {form[field('myFutureSupports')] || null}
      </p>
      <Grid container direction="row" className={classes.textSpacer} />
      <Grid container direction="row">
        <Grid item xs={12}>
          <label>{`What tasks do I need to complete to move toward my Plan ${planType}?`}</label>
        </Grid>
      </Grid>
      <Grid container direction="row">
        <Grid item xs={12} className={classes.textArea5RowSpacer + ' ' + classes.unprintedContent}>
          <FormControl fullWidth>
            <textarea
              aria-label={`my-future-plan-${planType}-tasks`}
              rows={2}
              maxLength={250}
              value={form[field('myFutureTasks')]}
              onChange={(event) => setForm({ ...form, [field('myFutureTasks')]: event.target.value })}
              disabled={disabled}
              className={`${classes.textAreaFont} ${classes.textAreaFixed}`}
              style={{ color: disabled && 'rgba(0, 0, 0, 0.2)' }}
            />
          </FormControl>
        </Grid>
      </Grid>
      <p className={classes.printedContent} style={{ whiteSpace: 'pre-wrap' }}>
        {form[field('myFutureTasks')] || null}
      </p>
    </Box>
  );
};

export default PlanSection;
